// Func = limiting Scope for this file
var lastScrollTop = 0;
//booking widget variables
if(document.getElementById('arriveInput')){
	var start = document.getElementById('arriveInput').value;
}
if(document.getElementById('departureInput')){
	var end = document.getElementById('departureInput').value;
}
var opened = 0;
var opencheck;

const getScrollPosition = (el = document.documentElement) => ({
	x: el.scrollLeft,
	y: el.scrollTop
  });

(function(){

	let currentURL = window.location.href;
	if( (currentURL.indexOf( "#formArt" )) != "-1" ){
		setTimeout( () => {
			$('html, body').animate({scrollTop: $('#formArt').offset().top}, 'slow');	
		}, 1000 )
		setTimeout( () => {
			$('html, body').animate({scrollTop: $('#formArt').offset().top  - 100}, 'slow');	
		}, 3000 )
	}

	$(document).ready(function () {

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });
		//Submenu anchors
		$('.lure-fishbar-chicago .sub-menu a').click(function(event){
			event.preventDefault();
			let anchorRef = $(this).attr('href');
			let id = anchorRef.split('#')[1];
			$('html, body').animate({
				scrollTop: $(`#${id}`).offset().top - 200
			}, 200);
		});
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		$('.submenu.privary-navigation__submenu').prev().addClass('dropdown');

		if( window.innerWidth <= 1100 ){
			// let allmainNav = document.getElementById('primary-nav').getElementsByTagName('a');
			let allmainNav = document.querySelectorAll('#primary-nav > .privary-navigation__list > .privary-navigation__item > a');
			console.log(allmainNav);
			let allmainLength = allmainNav.length;
			let oldNode = null;
			for(let i = 0; i < allmainLength; i++){
				allmainNav[i].addEventListener('click', function(e){
					if(this.nextElementSibling !== null){
						e.preventDefault();
						
						if(! this.nextElementSibling.classList.contains('open-item')){
							if(oldNode){
								oldNode.nextElementSibling.classList.remove('open-item');
								oldNode.classList.remove('open-item');
							}
							this.nextElementSibling.classList.add('open-item');
							this.classList.add('open-item');
						} else {
							this.nextElementSibling.classList.remove('open-item');
							this.classList.remove('open-item');
						}

						oldNode = this;
					}
				})
			}
		}


		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "mm/dd/yy";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	const mouseVideos = document.querySelectorAll('.mouse-videos');
	
	if(mouseVideos){
	
		mouseVideos.forEach( ( video ) => {
			if(window.screen.width > 1024){
				video.addEventListener('mouseenter' , ( ) =>{
					if(video.paused){
						video.play();
					}
				})
	
				video.addEventListener('ended' , function( ){
					this.currentTime = 0;
				})
			}else{
				video.autoplay = true;
				video.addEventListener('ended' , function( ){
					this.play();
				})
			}
			
		} )
		
	}

	if(document.getElementById('book-btn')){
		document.getElementById('book-btn').addEventListener('mouseenter' , function(){
			if(!bookingContainer.classList.contains('open')){
				this.innerHTML = 'BOOK NOW'
			}
		})
	
		document.getElementById('book-btn').addEventListener('mouseleave' , function(){
			if(!bookingContainer.classList.contains('open')){
				this.innerHTML = 'BOOK'
			}
		})
	}

	const btnMenuMobile = document.querySelectorAll('.js-btn-menu');
	const contNav = document.querySelector('.container-primary-nav');
	const closeNav = document.getElementById('close-nav');

	if(btnMenuMobile){
		btnMenuMobile.forEach((btnMenu) => {
			btnMenu.addEventListener('click' , () =>{
				contNav ? contNav.classList.toggle('open') : null;
			})
		})
	}

	if(closeNav){
		closeNav.addEventListener('click' , ()=>{
			contNav ? contNav.classList.remove('open') : null;
		})
	}

	//Booking close and open
	const bookingBTN = document.getElementById('book-btn');
	const bookingContainer = document.getElementById('bookingBox');

	if(bookingBTN){
		bookingBTN.addEventListener('click' , (e)=>{
			e.preventDefault();
			bookingContainer.classList.toggle('open');
			if(bookingContainer.classList.contains('open')){
				e.target.innerHTML = 'CLOSE';
			}else{
				e.target.innerHTML = 'BOOK';
			}
		});
	}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	// let headerWeb = document.getElementById('header');
	let menuSub = document.querySelector('.sub-menu');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}

			//test
			// linesVert.style.height = '800px';
			// console.log(linesVert.style.height = 800px)

		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	if(menuSub){
		if(document.querySelector('.video-container') && window.screen.width <= 1500){
			if(st > 490){
				menuSub.classList.add('down');
			} else {
				menuSub.classList.remove('down');
			}
		}else{
			
			if(st > 590){
				menuSub.classList.add('down');
			} else {
				menuSub.classList.remove('down');
			}
		}

	}

	if( (document.querySelector(`.top-content__wrapper`) || document.querySelector(`.top-content-default`) ) && document.querySelector(`.booking-fixed-cms`)){
		let heightTopContent = document.querySelector(`.top-content__wrapper`) ? document.querySelector(`.top-content__wrapper`).clientHeight : document.querySelector(`.top-content-default`).clientHeight;
		if( window.scrollY > (heightTopContent - 50) ){
			if( !document.querySelector(`.booking-fixed-cms`).classList.contains('fixed') ){
				document.querySelector(`.booking-fixed-cms`).classList.add('hide');
				setTimeout(() => {
					document.querySelector(`.booking-fixed-cms`).classList.add('fixed');
					if( document.querySelector(`nav.sub-menu`) ){
						document.querySelector(`.booking-fixed-cms`).classList.add('submenu');
					}
					setTimeout(() => {
						document.querySelector(`.booking-fixed-cms`).classList.remove('hide');
					}, 500);
				}, 500);
			}
		}else{
			if( document.querySelector(`.booking-fixed-cms`).classList.contains('fixed') ){
				document.querySelector(`.booking-fixed-cms`).classList.add('hide');
				setTimeout(() => {
					document.querySelector(`.booking-fixed-cms`).classList.remove('fixed');
					document.querySelector(`.booking-fixed-cms`).classList.remove('submenu');
					setTimeout(() => {
						document.querySelector(`.booking-fixed-cms`).classList.remove('hide');
					}, 500);
				}, 500);
			}
		}
	}


	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}




/** BOOKING WIDGET FUNCTIONALITY */
(function(){

	$(document).ready(function () {
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})

		$('#adults').on('change', function(){
			let adultsNumber = $(this).val();
			
			let valChild = $('#children').val();

			if(valChild != '0'){
				let newValue = adultsNumber;
				for (let i = 0; i < Number(valChild); i++) {
					newValue += '-' + '8';
				}
				$('#composition').val(newValue)
			}else{
				$('#composition').val(adultsNumber)
			}
		})

		$('#children').on('change', function(){
			let adultsNumber = $('#adults').val();

			let childrenNumber  = $(this).val();

			if(childrenNumber != '0'){
				let newValue = adultsNumber;
				for (let i = 0; i < Number(childrenNumber); i++) {
					newValue += '-' + '8';
				}
				$('#composition').val(newValue)
			}else{
				$('#composition').val(adultsNumber)
			}
		})

		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 2,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date; 
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				alternativeDates(start, end);
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});
	});

	function alternativeDates(start, end) { 
		let checkin = start.split("/"); 
		let checkout = end.split("/");
		let startDate = checkin[2]+'-'+checkin[0]+'-'+checkin[1];
		let endDate = checkout[2]+'-'+checkout[0]+'-'+checkout[1];
		let diff = new Date(endDate).getTime() - new Date(startDate).getTime();
		let days =  diff/(1000*60*60*24);
		$("#arriveInputAlt").val(startDate);
		$("#departureInputAlt").val(days);
	}


	document.addEventListener('DOMContentLoaded', function() {
		
		setTimeout(function() {
			if (document.querySelector('#bookingFixedContainer form #booking_cms_select_rooms')) {
				let textOption = document.querySelector('#bookingFixedContainer form #booking_cms_select_rooms')
				let optionTen = textOption.options[9];
				optionTen.textContent = '10+ Please reach out to our Sales Team to book your stay';
			}
		}, 4000);
	});
}());



/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		 var scrollParallax = []
		 var scrolled = 0
 
		 // screen height
		 var v_height = window.innerHeight
			 || document.documentElement.clientHeight
			 || document.body.clientHeight;
 
		 function doParallax(elm) {
 
			 let boundes = elm.dataset.parallax.split(",") // get it from html
			 //get distance in positive value
			 let distance = Math.abs(boundes[0] - boundes[1])
			 if (boundes[0] > boundes[1]) {
				 //get distance in negative value (to do the scroll inverse)
				 distance = distance * -1
			 }
			 //Equivalent distance using screen height + element height
			 const unit_scroll = distance / (v_height + elm.offsetHeight)
			 let temp = 0
 
			 let topElement = 0;
			 let element = elm;
 
			 let id_elem = elm.dataset.parallaxid
 
			 do {
				 topElement += element.offsetTop || 0;
				 element = element.offsetParent;
			 } while (element)
 
			 let parallaxFunction = function () {
				 //Obtain the distance between top screen and document top 0
				 scrolled = document.documentElement.scrollTop || window.pageYOffset
				 //Distance of bottom page to top of the element
				 let relative_distance = scrolled + v_height - topElement
				 //transpoling data to move the parallax element relative to the scroll of all the screen
				 temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				 //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				 elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			 }
 
			 scrollParallax[id_elem] = parallaxFunction
 
			 window.addEventListener('scroll', scrollParallax[id_elem])
 
		 }
 
		 let observers_parallax = document.querySelectorAll(".js-parallax-element")
 
		 if (observers_parallax) {
			 let options_parallax = {
				 root: null, // relative to document viewport
				 rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				 threshold: 0 // visible amount of item shown in relation to root
			 }
 
			 function handler_parallax(entries, observer) {
				 let entry;
				 entries.forEach(function (entry) {
					 if (entry.isIntersecting) {
						 doParallax(entry.target)
					 } else {
						 let id_elem = entry.target.dataset.parallaxid
						 window.removeEventListener('scroll', scrollParallax[id_elem])
					 }
				 })
			 }
 
			 let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			 let counter = 1
			 observers_parallax.forEach(function (element) {
				 observable_parallax.observe(element)
				 element.dataset.parallaxid = counter
				 counter++
			 })
		 }
		 	

		 //Loading preload
		 if( document.getElementById("home") && 
		 	 document.getElementById("preloader-home") && 
			 document.getElementById("preloader-overlay") &&
			 document.getElementById("fake-content")
			){
				setTimeout(() => {
					document.getElementById("preloader-home").classList.add("hide");
		 			document.getElementById("preloader-overlay").classList.add("hide");
		 			document.getElementById("fake-content").classList.add("hide");
				  }, "2000");
			// document.onreadystatechange = function () { 
			// 	let timePreload = 1700;
			// 	if(window.screen.width > 700){
			// 		timePreload = 1700;
			// 	}else{
			// 		timePreload = 0;
			// 	}

			// 	if (document.readyState === "complete") {
			// 		setTimeout(function(){
			// 			document.documentElement.scrollTop = 0;
			// 			document.getElementById("preloader-home").classList.add("hide");
			// 			document.getElementById("preloader-overlay").classList.add("hide");
			// 			document.getElementById("fake-content").classList.add("hide");

			// 			document.querySelector("#title-cont").style.animation = 'fade-top 1.3s ease  0.6s forwards';

			// 		},timePreload);
			// 	}
			// };
		}
	

		